<template>
  <div>
    <div v-if="!frenteCaixa.caixa.ultimoCaixa"
         class="row">
      <div class="col-8 d-flex flex-column justify-content-between">
        <Tabelas />
        <Filtros />
      </div>
      <div class="col-4">
        <Orcamentos />
      </div>
    </div>
    <div v-else
         class="pt-2">
      <span>Não existe caixa para a data atual</span>
    </div>
  </div>
</template>

<script>
  // Components
  import Orcamentos from "./Orcamentos/Orcamentos"
  import Filtros from "./Filtros/Filtros"
  import Tabelas from "./Tabelas/Tabelas"

  // Vuex
  import { mapState } from "vuex"

  export default {
    name: "FrenteDeCaixaConcluidos",
    components: {
      Orcamentos,
      Filtros,
      Tabelas
    }, 
    props: {
      propOrdensServico: {type: Array, default: null}
    },
    computed: mapState(['frenteCaixa']),
  }
</script>

<style scoped>
 
</style>